var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6747 0C19.625 0.0277401 20.253 0.959807 19.9029 1.85859C19.4472 3.04031 18.9748 4.21649 18.508 5.39267C16.713 9.94205 14.918 14.4859 13.1286 19.0352C12.9119 19.5901 12.5395 19.9396 11.9393 19.9951C11.2891 20.0505 10.7278 19.6344 10.55 18.9798C10.2277 17.7925 9.90537 16.5997 9.58861 15.4124C9.24961 14.1641 8.91062 12.9102 8.58274 11.6619C8.5494 11.5288 8.48271 11.4733 8.35489 11.4345C5.91525 10.7853 3.48117 10.1251 1.04153 9.47047C0.446901 9.30957 0.0356631 8.83799 0.00231945 8.261C-0.0310242 7.66736 0.296855 7.15694 0.87481 6.92947C6.16533 4.84897 11.4558 2.76846 16.7408 0.687954C17.2132 0.50487 17.68 0.310689 18.1524 0.133152C18.3246 0.0776723 18.5025 0.0443841 18.6747 0Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/navigator.6c5f6e1f1b3f67b932b56d1506e961cb.svg";
export { ForwardRef as ReactComponent };